/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";

import Header from "components/Headers/Header.js";
import { legendsRepo } from "data/repositories/legendsRepo";
import LegendsList from "views/content/LegendsList";

const Index = (props) => {
  const [mediaFilter, setMediaFilter] = useState("all");
  const [stats, setStats] = useState({
    total: 0,
    withImage: 0,
    withAudio: 0,
    withVideo: 0,
  });

  useEffect(() => {
    fetchLegends();
  }, []);

  const fetchLegends = async () => {
    try {
      const data = await legendsRepo.list();

      const activeLegends = (data || []).filter((l) => l?.isActive !== false);
      
      const total = activeLegends.length;
      const withImage = activeLegends.filter((l) => l.imageUrl).length;
      const withAudio = activeLegends.filter((l) => l.audioUrl).length;
      const withVideo = activeLegends.filter((l) => l.videoUrl || l.videoLink).length;
      
      setStats({ total, withImage, withAudio, withVideo });
    } catch (error) {
      console.error("Error fetching legends:", error);
    }
  };

  return (
    <>
      <Header
        stats={stats}
        activeFilter={mediaFilter}
        onFilterChange={setMediaFilter}
      />
      <LegendsList embedded mediaFilter={mediaFilter} />
    </>
  );
};

export default Index;
